import { useSortable } from "@dnd-kit/sortable";
import { ActionButton } from "../Buttons/ActionButton";

export const RowDragHandleCell = ({ rowId }: { rowId: string }) => {
  const { attributes, listeners } = useSortable({
    id: rowId,
  });
  return <ActionButton icon="grip-vertical" {...attributes} {...listeners} />;
};
